Object.defineProperty(exports, '__esModule', { value: true });
var styles_1 = require('@material-ui/core/styles');
var React = require('react');
var recompose_1 = require('recompose');
var styles = function (theme) {
    return styles_1.createStyles({
        triolietBackgroundContainer: {
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'hidden',
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            padding: 0,
            margin: 0,
            position: 'relative',
            zIndex: 100,
            minHeight: '100vh',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
        },
        topBar: {
            height: 40,
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            background: 'white',
            display: 'flex',
            alignItems: 'center',
            '&:before': {
                content: "''",
                position: 'absolute',
                background: 'white',
                width: '25%',
                height: 120,
                transform: 'skewX(-45deg)',
                zIndex: '-1',
            }
        },
        logo: {
            height: 50,
            width: '15%',
            objectFit: 'contain',
            marginTop: 30,
            marginLeft: '2.5%',
        },
    });
};
var TriolietBackground = function (props) {
    var classes = props.classes, children = props.children, hideLogo = props.hideLogo,
        imagesBaseUrl = props.imagesBaseUrl;
    var backgroundImage = {
        backgroundImage: 'url('+ imagesBaseUrl + 'trioliet/assets/images/account/background.svg)',
    };
    return (React.createElement("div", { className: classes.triolietBackgroundContainer, style: backgroundImage },
        !hideLogo && (React.createElement("div", { className: classes.topBar },
            React.createElement("img", {
                alt: 'trioliet',
                src: imagesBaseUrl + 'trioliet/assets/images/common/logo/logo-rgb.png',
                className: classes.logo
            }))),
        children));
};
exports.default = recompose_1.compose(styles_1.withStyles(styles))(TriolietBackground);
//# sourceMappingURL=TriolietBackground.js.map